import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useChannels({ user }) {
  const [channels, setChannels] = useState(undefined);

  useEffect(() => {
    if (user === undefined || user === null) {
      setChannels(undefined);
      return;
    }
    setChannels(undefined);
    axios
      .get(routes.api.slack.channels, {
        params: {
          user_id: user.attributes.slack_user_id,
        },
      })
      .then((response) => {
        setChannels(response.data);
      }).catch(() => {
        setChannels(null);
      });
  }, [user]);

  return channels;
}
